import axios, { AxiosResponse } from 'axios';

const chatbot = axios.create({
  baseURL: 'https://us-central1-testevocacionalunilasalle.cloudfunctions.net/api'
});

export function clearSession(): void {
  sessionStorage.clear();
}

export async function createLeader(email: string, name: string, phone: string): Promise<void> {
  return chatbot.post('/leaders', {
    email,
    name,
    phone
  });
}

export async function createSession(): Promise<void> {
  const response = await chatbot.get('/session');
  sessionStorage.setItem('sessionId', response.data.sessionId);
}

export function sendMessage(message: string): Promise<AxiosResponse> {
  const sessionId = sessionStorage.getItem('sessionId');
  return chatbot.post('/message', {
    input: {
      text: message
    },
    sessionId
  });
}
